__turbopack_context__.v({
  "chatList": "AdminChatList-module__zZaJdG__chatList",
  "chatList__search": "AdminChatList-module__zZaJdG__chatList__search",
});
